<template>
	<router-view key="clients"></router-view>
</template>

<script>
	export default {}
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/Clients/Index.vue